export { default } from './CardPageProductLists'
